import React, { useMemo } from 'react';
import useSessionVideo from './useSessionVideo';
import { timeSpanToSeconds } from '../../services/sessionModels';
import CardHeader from '../Util/CardHeader';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import styled from 'styled-components';
import { hms } from '../Sessions/Upload/VideoStatus';

interface Props {
  video: string;
}

interface PropertyProps {
  k: string;
  v?: string | number | null;
}

const Property: React.FunctionComponent<PropertyProps> = ({ k, v }) => {
  return (
    <PropContainer>
      <PropKey>{k}</PropKey>
      <PropValue>{v}</PropValue>
    </PropContainer>
  );
};

const PropContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  margin-bottom: 2px;
`;

const PropKey = styled.div`
  flex-grow: 0;
  font-size: 18px;
  font-weight: 500;
  flex-basis: 150px;
  flex-shrink: 0;
`;

const PropValue = styled.div`
  flex-grow: 3;
  font-size: 16px;
  overflow-wrap: anywhere;
`;

const PitchVideoSettingsView: React.FunctionComponent<Props> = (props) => {
  const video = useSessionVideo(props.video);

  const calibration = useMemo(() => {
    if (video?.calibration) {
      return JSON.parse(video.calibration);
    }
    return {};
  }, [video]);

  return (
    <Box>
      <div>
        <CardHeader>Video properties</CardHeader>
        <div className="sciui-grid" key="grid">
          <div className="sciui-grid-item-xs-12 sciui-grid-item-l-6" key="left">
            <Property k="URL" v={video?.url} />
            <Property k="Bitrate" v={video?.bitrate} />
            <Property k="Framerate" v={video?.fps} />
            <Property k="Width" v={video?.width} />
            <Property k="Height" v={video?.height} />
            <Property k="Codec" v={video?.encoding} />
            <Property k="Sync offset" v={video ? timeSpanToSeconds(video.syncOffset) : undefined} />
            <Property k="Duration" v={hms(video ? timeSpanToSeconds(video.length) : undefined)} />
          </div>
          <div className="sciui-grid-item-xs-12 sciui-grid-item-l-6" key="right">
            <Editor allowedModes={['tree', 'text']} value={calibration} />
          </div>
        </div>
      </div>
    </Box>
  );
};

const Box = styled.div`
  flex: 1;
  margin-top: 32px;
  margin-bottom: 32px;
`;

export default PitchVideoSettingsView;
